import React from 'react';
import { Container } from './styles';
import Search from '~/components/Search';

export const RelatorioDeConferenciaDeEntrada: React.FC = () => {
  function defaultOnlyReport() {
    return false;
  }
  return (
    <Container>
      <Search
        codTela={324}
        onlyReport
        newData={defaultOnlyReport}
        onRowClick={defaultOnlyReport}
      />
    </Container>
  );
};
